var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSplashCoach = function SvgSplashCoach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.63,
    cy: 10.458,
    r: 0.829,
    stroke: "#9E9B9A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.561,
    cy: 10.458,
    r: 0.829,
    stroke: "#9E9B9A"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9E9B9A",
    d: "M9.294 10.458h18.603"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9E9B9A",
    strokeLinecap: "round",
    d: "M8.63 17.102c-.665-.775-2.207-1.329-3.156 0-1.187 1.66 1.384 3.654 3.156 4.318M8.796 17.101c.664-.775 2.206-1.328 3.156 0 1.186 1.661-1.384 3.654-3.156 4.319M8.63 11.787v3.654M30.222 15.773h-1.66m-1.994 5.315h1.993m0-5.315h-.996c-.734 0-1.33.595-1.33 1.329v0c0 .733.596 1.328 1.33 1.328h1.993c.733 0 1.328.595 1.328 1.329v0c0 .734-.594 1.329-1.328 1.329h-.997m0-5.315v-.665m0 5.98v.664M28.561 11.455v2.482M17.267 10.458v15.28h2.657m0-15.28v12.623M20.256 29.725h2.654a1 1 0 0 0 1-1v-.326a1 1 0 0 0-1-1h-8.63a1 1 0 0 0-1 1v.326a1 1 0 0 0 1 1H17.6M18.595 7.136V5.143"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#9E9B9A",
    d: "M20.753 9.13a2.157 2.157 0 1 1-4.315 0 2.157 2.157 0 0 1 4.315 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#9E9B9A",
    d: "M19.424 9.129a.829.829 0 1 1-1.657 0 .829.829 0 0 1 1.657 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9E9B9A",
    d: "M15.273 26.569a.83.83 0 0 1 .83-.83h4.984a.83.83 0 1 1 0 1.66h-4.983a.83.83 0 0 1-.83-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E9B9A",
    d: "M20.356 24.51a.432.432 0 1 1-.863 0 .432.432 0 0 1 .863 0M19.459 29.725a.432.432 0 1 1-.864 0 .432.432 0 0 1 .864 0"
  }))));
};
export default SvgSplashCoach;